import { Injectable } from '@angular/core'
@Injectable()
export class AppConfigurationService {
    private appConfig: any

    constructor() {}

    getConfig() {
        return this.appConfig
    }

    setConfig(localAppConfig: any) {
        this.appConfig = localAppConfig
    }

    getConfigObject(): Promise<any> {
        return this.appConfig
    }
}
